import React from 'react';
import { Fab, Tooltip, Box } from '@mui/material';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import { motion } from 'framer-motion';

function WhatsAppButton() {
  const whatsappNumber = '+1234567890'; // Replace with your actual WhatsApp number
  const whatsappMessage = 'Hello! I would like to know more about your flowers.';
  
  const handleClick = () => {
    const encodedMessage = encodeURIComponent(whatsappMessage);
    window.open(`https://wa.me/${whatsappNumber}?text=${encodedMessage}`, '_blank');
  };

  return (
    <Box
      component={motion.div}
      initial={{ scale: 0, opacity: 0 }}
      animate={{ scale: 1, opacity: 1 }}
      transition={{
        type: "spring",
        stiffness: 260,
        damping: 20,
        delay: 1
      }}
      sx={{
        position: 'fixed',
        bottom: 32,
        right: 32,
        zIndex: 1000
      }}
    >
      <Tooltip title="Chat with us on WhatsApp" placement="left">
        <Fab
          color="success"
          aria-label="whatsapp"
          onClick={handleClick}
          sx={{
            bgcolor: '#25D366',
            '&:hover': {
              bgcolor: '#20BD5C'
            },
            width: 60,
            height: 60,
            boxShadow: '0 4px 12px rgba(37, 211, 102, 0.4)'
          }}
        >
          <WhatsAppIcon sx={{ fontSize: 32 }} />
        </Fab>
      </Tooltip>
    </Box>
  );
}

export default WhatsAppButton;
